import { useSetRecoilState } from 'recoil';

import { paymentMethodChangeAcceptance } from '../atoms/paymentMethodChangeAcceptance';

export default function useSetPaymentMethodChangeAcceptance() {
  return useSetRecoilState(paymentMethodChangeAcceptance);
}
